import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";

const WaiverVersionHistory = () => {
  const { waiver } = useOutletContext();

  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();
  const { waiverId } = useParams();

  const [loading, setLoading] = useState(true);
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const fetchVersionHistory = async () => {
      try {
        const res = await fetch(
          `${API_URL.BUSINESS_WAIVER_VERSION_HISTORY}/${waiverId}`,
          {
            headers: {
              Authorization: `Bearer ${business.token}`,
              "x-session-id": business.sessionId,
              "x-frontend-url": window.location.pathname,
            },
          }
        );

        const data = await res.json();

        if (data.success) {
          setVersions(data.versions || []);
        }
      } catch (err) {
        console.error("Failed loading version history", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVersionHistory();
  }, [business, waiverId, navigate]);

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const handleViewVersion = (versionWaiverId) => {
    navigate(
      `/business/waiverviewer/${versionWaiverId}`
    );
    /* navigate(
      `/business/waiverviewer/${versionWaiverId}/version-history`
    ); */
  };

  const handleViewSignatures = (waiverId) => {
    navigate(
      `/business/waivers/signatures/${waiverId}`
    );
  };

  if (loading) {
    return (
      <div className="p-8">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h2 className="text-2xl font-semibold mb-6">
        Version History
      </h2>

      <div className="overflow-x-auto border border-gray-200 rounded-xl">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-medium">
                Version
              </th>

              <th className="px-6 py-4 text-left text-sm font-medium">
                Signatures
              </th>

              <th className="px-6 py-4 text-left text-sm font-medium">
                Published
              </th>

              <th className="px-6 py-4 text-left text-sm font-medium">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {versions.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="px-6 py-10 text-center text-gray-500"
                >
                  No version history found.
                </td>
              </tr>
            ) : (
              versions.map((version) => (
                <tr
                  key={version._id}
                  className="border-t border-gray-100"
                >
                  <td className="px-6 py-5">
                    {version.versionLabel}
                  </td>

                  <td className="px-6 py-5">
                    {version.signatureCount ?? 0}
                  </td>

                  <td className="px-6 py-5 text-gray-600">
                    {formatDate(version.publishedAt)}
                  </td>

                  <td className="px-6 py-5">
                    <div className="flex gap-4">
                      <button
                        onClick={() =>
                          handleViewVersion(version?._id)
                        }
                        className="text-sm underline"
                      >
                        View Version
                      </button>

                      <button
                        onClick={() =>
                          handleViewSignatures(version._id)
                        }
                        className="text-sm underline"
                      >
                        View Signatures
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WaiverVersionHistory;